import React, { useEffect } from 'react';
import apiClient from 'apiClient';
import FirmAdminListComponent from 'components/FirmAdminList/FirmAdminList';
import { RouteComponentProps } from 'react-router-dom';
import { admins as adminsPath } from 'routes/routePaths';
import { useDispatch, useSelector } from 'react-redux';
import { storeAdmins, updateAdminStatus } from 'store/admins/actions';
import { AdminViewModel, State } from 'store/admins/types';
import { getAdminsForList } from 'store/admins/selectors';
import useBodyClass from 'helpers/hooks/useBodyClass';

const FirmAdminList: React.FC<RouteComponentProps> = ({ history }: RouteComponentProps) => {
  const { admins }: State = useSelector((state: any) => state.adminsReducer);
  const firmAdmins = useSelector(() => getAdminsForList(admins));
  const dispatch = useDispatch();
  useBodyClass('light');

  useEffect(() => {
    let shouldCancel = false;

    const getFirmAdminList = async () => {
      const res = await apiClient.get('/api/v1/broker-management/admins/');
      if (!shouldCancel) dispatch(storeAdmins(res.data));
    };

    getFirmAdminList();

    return () => {
      shouldCancel = true;
    };
  }, [dispatch]);

  const updateStatus = async (firmAdmin: AdminViewModel, newStatus: boolean) => {
    dispatch(updateAdminStatus(firmAdmin, newStatus));
  };

  const redirectToCreatePage = () => {
    history.push(adminsPath.register);
  };

  return (
    <FirmAdminListComponent firmAdmins={firmAdmins} updateStatus={updateStatus} onAddNewItem={redirectToCreatePage} />
  );
};

export default FirmAdminList;
